import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';

import {environment} from '@Env/environment';
import {Feedback} from './feedback.model';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FeedbackService extends DaoGeneric<Feedback> {
  private url = `${environment.baseUrl}/api_bdc/feedback/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  public exportExcel() {
    const url = `${this.url}export_excel/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(
      map((data: any) => new Blob([data]))
    );
  }
}
